/**
 * Created by Ning Jiang on 2022-03-18.
 */

import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export interface IImageIntroPageConfig {
    texture:PIXI.Texture;
    position:PIXI.Point; // center
    scale:number;
}

export class ImageIntroPage extends SlideShowPage {

    constructor(config:IImageIntroPageConfig[]) {
        super(undefined, undefined)

        // const bg = new PIXI.Sprite(ImgLoader.getImgTexture("introFeatureBG"));
        // bg.anchor.set(0.5);
        // bg.position.set(0, 0);
        // this.addChildAt(bg, 0);

        config.forEach((pageConfig) => {
            const image = new PIXI.Sprite(pageConfig.texture);
            image.anchor.set(0.5);
            image.scale.set(pageConfig.scale);
            image.position.set(pageConfig.position.x, pageConfig.position.y);
            this.addChild(image);
        })
    }
}